import { MutationTree } from 'vuex';
import { ApplicationState } from './types';

export const mutations: MutationTree<ApplicationState> = {};
